import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout';
import AuthLayout from './components/AuthLayout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import LoginPage from './pages/auth/Login';
import RegisterPage from './pages/auth/Register';
import PrivateRoute from './components/PrivateRoute';
import BlogRoutes from './features/blog/routes';
import BlogManagement from './pages/admin/BlogManagement';
import NavigationManagement from './pages/admin/NavigationManagement';
import CloudManagement from './pages/admin/CloudManagement';
import ToolsManagement from './pages/admin/ToolsManagement';
import Navigation from './pages/Navigation';
import Cloud from './pages/Cloud';
import Tools from './pages/Tools';
import { Suspense } from 'react';
import Loading from './components/common/Loading';
import { AuthProvider } from './components/AuthProvider';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorPage from './components/ErrorPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ErrorBoundary>
        <AuthProvider>
          <Suspense fallback={<Loading />}>
            <Outlet />
          </Suspense>
        </AuthProvider>
      </ErrorBoundary>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <PublicLayout />,
        children: [
          { path: '', element: <Home /> },
          { path: 'home', element: <Home /> },
          { path: 'navigation', element: <Navigation /> },
          { path: 'blog/*', element: <BlogRoutes /> },
          { path: 'cloud', element: <Cloud /> },
          { path: 'tools/*', element: <Tools /> }
        ]
      },
      {
        path: 'auth',
        element: <AuthLayout />,
        children: [
          { path: 'login', element: <LoginPage /> },
          { path: 'register', element: <RegisterPage /> }
        ]
      },
      {
        path: 'admin',
        element: <PrivateRoute><Layout /></PrivateRoute>,
        children: [
          { path: '', element: <Dashboard /> },
          { path: 'blog/*', element: <BlogManagement /> },
          { path: 'navigation', element: <NavigationManagement /> },
          { path: 'cloud', element: <CloudManagement /> },
          { path: 'tools', element: <ToolsManagement /> }
        ]
      }
    ]
  }
]);

export default function App() {
  return (
    <RouterProvider router={router} />
  );
}